import React from 'react';
import { DxButton, DxContainer, DxGrid } from '@dvag/design-system-react';
import i18next from 'i18next';

interface BottomButtonsProps {
  navigateToNextSteps: () => void;
  navigateToDocumentAppointment: () => void;
}

export const BottomButtons: React.FC<BottomButtonsProps> = ({
  navigateToNextSteps,
  navigateToDocumentAppointment,
}) => (
  <DxContainer color="background" className="advisor-bottom-button-container">
    <DxGrid mq1="12/*" mq3="6-6">
      <DxButton
        stretch
        data-testid="button-to-next-steps"
        id="button-to-next-steps"
        onClick={navigateToNextSteps}
        type="secondary-s"
        label={i18next.t('analyseDashboard.buttons.nextSteps')}
      />
      <DxButton
        stretch
        data-testid="button-to-interview-conclusion"
        id="button-to-interview-conclusion"
        onClick={navigateToDocumentAppointment}
        type="secondary-s"
        label={i18next.t('analyseDashboard.buttons.documentAppointment')}
      />
    </DxGrid>
  </DxContainer>
);
